import i18n from './i18n'
import css from './index.module.css'

import { Config } from '#/global/helper/Config'

interface Props {
    onClose: () => void
}
export const Buttons = ({ onClose }: Props) => {
    const t = i18n[Config.getLang()]
    return (
        <div className={css.container}>
            <button className="dek-button dek-button-white" onClick={onClose} role="button" type="button">
                {t.continue}
            </button>
            <a className="dek-button dek-button-green" href="/kosik" role="button">
                {t.cart}
            </a>
        </div>
    )
}
